import Vue from 'vue'
import Router from 'vue-router'
import Index from './views/Index.vue'
import Console from './views/Console.vue'
import Login from './views/Login.vue'
import NotFound from './views/NotFound.vue'
import ReportDetailPage from './views/ReportDetailPage.vue'
import ReportDetailPagePurchase from './views/ReportDetailPagePurchase.vue'
import Instruction from './views/Instruction.vue'
import ChannelFlowDetails from './views/ChannelFlowDetails.vue'
import ReportDetailUnsettle from "@/views/ReportDetailUnsettle";
import RuleReview from "@/views/RuleReview";
import ServiceChargeView from "@/views/ServiceChargeView";
import ServiceChargeWallet from "@/views/ServiceChargeWallet";
import InvoiceInfoView from "@/views/InvoiceInfoView";
import ManagerView from "./views/ManagerView"
import LabelView from "@/views/LabelView";
import BlockedInfoView from "@/views/BlockedInfoView";
import store from "@/store";
import DataAnalysis from "@/views/dataAnalysis"
import PurchaseSaleStorage from '@/views/PurchaseSaleStorage'
import SavePackage from '@/views/SavePackage'
import EditPackage from '@/views/EditPackage'
import Package from '@/views/Package'
import SupplierInfo from '@/views/SupplierInfo'
import CoreAdmin from "@/views/CoreAdmin";
import PackageExplorer from "@/views/PackageExplorer";
import SalePunchInfo from "@/views/SalePunchInfo";
import GetPhoneNumber from "@/views/GetPhoneNumber";
import LoginSaleAccount from "@/views/LoginSaleAccount.vue";
import ProductManagement from "@/views/ProductManagement.vue";
import OrangevImport from "@/views/OrangevImport.vue";
import LoginManagerAccount from "@/views/LoginManagerAccount.vue";
import ProblemAnalysis from "@/views/ProblemAnalysis";
import DataUpload from "@/views/DataUpload";
import ProcessApproval from "@/views/ProcessApproval";
import OcrIndicator from "@/views/OcrIndicator";

Vue.use(Router)

const router = new Router({
  // mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/login',
      component: Login,
      meta: {
        title: 'OrangeV - 登录'
      }
    },
    {
      path: '/',
      component: Index,
      children: [
        {
          path: '/console',
          name: 'console',
          component: Console,
          meta: {
            title: 'OrangeV - 数据中心'
          }
        },
        {
          path: '/Instruction',
          name: 'Instruction',
          component: Instruction,
          meta: {
            title: 'OrangeV - 数据中心 - 特发指令'
          }
        }, {
          path: '/ReportDetailPage',
          name: 'ReportDetailPage',
          component: ReportDetailPage,
          meta: {
            title: 'OrangeV - 数据中心 - 明细报表'
          }
        },
        {
          path: '/RuleReview',
          name: 'RuleReview',
          component: RuleReview,
          meta: {
            title: 'OrangeV - 规则审核管理'
          }
        },
        {
          path: '/ReportDetailPagePurchase',
          name: 'ReportDetailPagePurchase',
          component: ReportDetailPagePurchase,
          meta: {
            title: 'OrangeV - 数据中心 - 导购员名单'
          }
        },
        {
          path: '/404',
          component: NotFound,
          meta: {
            title: 'OrangeV - 404'
          }
        },
        {
          path: '/ChannelFlowDetails',
          name: 'ChannelFlowDetails',
          component: ChannelFlowDetails,
          meta: {
            title: 'OrangeV - 数据中心 - 渠道红利流水明细'
          }
        },
        {
          path: '/ReportDetailUnsettle',
          name: 'ReportDetailUnsettle',
          component: ReportDetailUnsettle,
          meta: {
            title: 'OrangeV - 数据中心 - 未发放提出的销售明细'
          }
        }, {
          path: '/ServiceChargeView',
          name: 'ServiceChargeView',
          component: ServiceChargeView,
          meta: {
            title: 'OrangeV - 数据中心 - 服务费明细'
          }
        }, {
          path: '/ManagerView',
          name: 'ManagerView',
          component: ManagerView,
          meta: {
            title: 'OrangeV - 数据中心 - 导购业务员对接'
          }
        }, {
          path: '/LabelView',
          name: 'LabelView',
          component: LabelView,
          meta: {
            title: 'OrangeV - 数据中心 - 自定义标签'
          }
        },
        {
          path: '/DataAnalysis',
          name: 'DataAnalysis',
          component: DataAnalysis,
          meta: {
            title: 'OrangeV - 数据中心 - 数据分析'
          }
        },
        {
          path: '/PurchaseSaleStorage',
          name: 'PurchaseSaleStorage',
          component: PurchaseSaleStorage,
          meta: {
            title: 'OrangeV - 数据中心 - 进销存管理'
          }
        },
        {
          path: '/Package',
          name: 'Package',
          component: Package,
          meta: {
            title: 'OrangeV - 数据中心 - 提成规则管理'
          }
        },
        {
          path: '/SavePackage',
          name: 'SavePackage',
          component: SavePackage,
          meta: {
            title: 'OrangeV - 数据中心 - 新增提成规则'
          }
        },
        {
          path: '/EditPackage',
          name: 'EditPackage',
          component: EditPackage,
          meta: {
            title: 'OrangeV - 数据中心 - 修改提成规则'
          }
        },
        {
          path: '/SupplierInfo',
          name: 'SupplierInfo',
          component: SupplierInfo,
          meta: {
            title: 'OrangeV - 数据中心 - 业务员权限配置'
          }
        }, {
          path: '/CoreAdmin',
          name: 'CoreAdmin',
          component: CoreAdmin,
          meta: {
            title: 'OrangeV - 数据中心 - 全局管理设置'
          }
        }, {
          path: '/ServiceChargeWallet',
          name: 'ServiceChargeWallet',
          component: ServiceChargeWallet,
          meta: {
            title: 'OrangeV - 数据中心 - 服务费账户明细'
          }
        }, {
          path: '/InvoiceInfoView',
          name: 'InvoiceInfoView',
          component: InvoiceInfoView,
          meta: {
            title: 'OrangeV - 数据中心 - 发票明细'
          }
        }, {
          path: '/BlockedInfoView',
          name: 'BlockedInfoView',
          component: BlockedInfoView,
          meta: {
            title: 'OrangeV - 数据中心 - 冻结名单管理'
          }
        }, {
          path: '/PackageExplorer',
          name: 'PackageExplorer',
          component: PackageExplorer,
          meta: {
            title: 'OrangeV - 数据中心 - 资源包管理'
          }
        }, {
          path: '/SalePunchInfo',
          name: 'SalePunchInfo',
          component: SalePunchInfo,
          meta: {
            title: 'OrangeV - 数据中心 - 在店打卡数据明细表'
          }
        },
        {
          path: '/GetPhoneNumber',
          name: 'GetPhoneNumber',
          component: GetPhoneNumber,
          meta: {
            title: 'OrangeV - 数据中心 - 在店打卡数据明细表'
          }
        },
        {
          path: '/LoginSaleAccount',
          name: 'LoginSaleAccount',
          component: LoginSaleAccount,
          meta: {
            title: 'OrangeV - 数据中心 - 导购账号替身登录'
          }
        },
        {
          path: '/LoginManagerAccount',
          name: 'LoginManagerAccount',
          component: LoginManagerAccount,
          meta: {
            title: 'OrangeV - 数据中心 - 导购账号替身登录'
          }
        },
        {
          path: '/ProblemAnalysis',
          name: 'ProblemAnalysis',
          component: ProblemAnalysis,
          meta: {
            title: 'OrangeV - 数据中心 - 问题分析'
          }
        },
        {
          path: '/ProductManagement',
          name: 'ProductManagement',
          component: ProductManagement,
          meta: {
            title: 'OrangeV - 数据中心 - 产品管理'
          }
        },
        {
          path: '/OrangevImport',
          name: 'OrangevImport',
          component: OrangevImport,
          meta: {
            title: 'OrangeV - 数据中心 - 导出数据'
          }
        },
        {
          path: '/DataUpload',
          name: 'DataUpload',
          component: DataUpload,
          meta: {
            title: 'OrangeV - 数据中心 - 部署资料上传'
          }
        },
        {
          path: '/ProcessApproval',
          name: 'ProcessApproval',
          component: ProcessApproval,
          meta: {
            title: 'OrangeV - 数据中心 - 流程审批'
          }
        },
        {
          path: '/OcrIndicator',
          name: 'OcrIndicator',
          component: OcrIndicator,
          meta: {
            title: 'OrangeV - 数据中心 - 橙视迅结'
          }
        }
      ]
    },
    {
      path: '*',
      redirect: {path: '/404'}
    }
  ]
})

// 全局路由守卫
router.beforeEach((to, from, next) => {
  store.commit('clearTips')
  store.commit('toTrainingButton',false)
  const LOGINURL = '/login'
  let url, user

  url = to.path
  user = sessionStorage.getItem('user')

  if (url === LOGINURL) {
    sessionStorage.removeItem('user')
  }

  // 判断是否登录
  if (!user && url !== LOGINURL && url !== '/GetPhoneNumber') {
    let href = window.location.href
    if (href.includes('?from=v')) {
      sessionStorage.setItem('from', 'v')
      href = href.replace(/\?from=v.*/, '')
      window.location.replace(href)
    } else {
      next({path: LOGINURL})
    }
  } else {
    next()
  }
})

export default router
